import { render } from "./LoginView.vue?vue&type=template&id=6444fd1c"
const script = {}
script.render = render

export default script